import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROUTES } from '@/constants/routes';
import { hasAccess } from '@/routes/routeHelpers';
import { appRoutes } from '@/routes';

export default function ProtectedRoute({ children, path }) {
    const userData = useSelector((state) => state.user.userData);
    const userRole = userData?.role;

    const route = appRoutes.find((r) => r.path === path);

    if (!route || !hasAccess(route, userRole)) {
        return <Navigate to={ROUTES.NUMBER_MANAGEMENT} replace />;
    }

    return children;
}
